import React from "react";
import FeatherIcon from "feather-icons-react";
import { useTheme } from "@mui/material";

import {
  IconFileTypeDefault,
  IconFileTypeExcel,
  IconFileTypePdf,
  IconFileTypeWord,
} from "@icons/files";

const wordExtensions = ["doc", "docx", "docm", "odt", "rtf"];
const excelExtensions = ["xls", "xlsx", "xlsm", "csv", "ods"];

export const getFileTypeIcon = (fileName: string): JSX.Element => {
  const theme = useTheme();

  const ext = fileName.split(".").pop()?.toLowerCase();

  if (!ext) return <IconFileTypeDefault sx={{ fontSize: 24 }} />;

  if (ext === "pdf") return <IconFileTypePdf sx={{ fontSize: 24 }} />;
  if (wordExtensions.includes(ext))
    return <IconFileTypeWord sx={{ fontSize: 24 }} />;
  if (excelExtensions.includes(ext))
    return <IconFileTypeExcel sx={{ fontSize: 24 }} />;

  return (
    <FeatherIcon
      color={theme.palette.custom.purple[400]}
      fill={theme.palette.custom.purple[400]}
      icon="folder"
      size={20}
    />
  );
};
